import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import { ProveedorService } from '../../../services/proveedor.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Router } from '@angular/router';
import { GridComponent } from '../../../controls/grid/grid.component';

@Component({
  selector: 'proveedor-list',
  templateUrl: './proveedor-list.component.html',
  styleUrls: ['./proveedor-list.component.css'],
  providers: [ProveedorService,SessionService]
})
export class ProveedorListComponent implements OnInit {
	public loading = false;
    public msg: SweetMessage;
	public title: String;
	public dataGrid: any;
	public bsModalRef: BsModalRef;
	public router: Router;
	@ViewChild(GridComponent) data: GridComponent;

	constructor(
		private ss: SessionService,
		private proveedorService: ProveedorService,
		private modalService: BsModalService,
	) {
		this.title = "Proveedores";
		this.msg = new SweetMessage();

		this.dataGrid = {
			keyGrid: "proveedor",
			perPage: 10,
			endPoint: "/proveedores",
			routeEdit: "/compras/proveedores-edit",
			qs: "&sort=razon_social",
			columsDef: [
				{
					Header: "Identificación",
					Field: "dni",
					Searchable: true
				},
				{
					Header: "Razón social",
					Field: "razon_social",
					Searchable: true
				},
				{
					Header: "Correo",
					Field: "correo",
					Searchable: true
				},
				{
					Header: "Teléfono",
					Field: "telefono",
					Searchable: true
				},
				{
					Header: "Celular",
					Field: "celular",
					Searchable: true
				},
				{
					Header: "Obligado",
					Field: "es_obligado",
					mask: es_obligado => es_obligado? "SI" : "NO"
				},
				/*{
					Header: "Contribuyente",
					Field: "es_contribuyente",
					mask: es_contribuyente => es_contribuyente? "SI" : "NO"
				}*/
			]
		};
	}

	ngOnInit() {
	}

	openModalCargaMasiva(template: TemplateRef<any>) {
		this.bsModalRef = this.modalService.show(template, Object.assign({}, {class: 'modal-xlg'}));
	}

	upload(event){
		if( event.target.files.length > 0 ){
            let file = event.target.files[0];
            let fr = new FileReader();

            fr.onload = (e) =>{
                let text = fr.result;
                let rows = text.toString().split("\n");
                let arrayFilas: string[][] = [];

                let data: any = {};
                data['empresa_id'] = this.ss.getData('empresa_id');
                data['sucursal_id'] = this.ss.getData('sucursal_id');
                data['usuario_id'] = this.ss.getData('empresa_id');
                data["data"] = [];

                for (let i = 0; i < rows.length; i++) {
                    
                    if (rows[i].length != 0) {
                        let row = rows[i].split(";");                        
                        let _row = {};

                        _row["tipo_persona"] = row[0];
                        _row["tipo_dni"] = row[1];
                        _row["dni"] = row[2];
                        _row["razon_social"] = row[3];
                        _row["nombre_comercial"] = row[4];
                        _row["actividad_economica_id"] = row[5];
                        _row["correo"] = row[6];
                        _row["telefono"] = row[7];
                        _row["celular"] = row[8];
                        _row["direccion"] = row[9];
                        _row["lleva_contabilidad"] = row[10];
						
                        data['data'].push(_row);
                    }
                }

                this.loading = true;
                this.proveedorService.cargaMasiva(JSON.stringify(data)).subscribe(
                    res => {
                        this.loading = false;
						this.msg.showMessage('success-message', res.message);
						this.data.getData();
                    },
                    err => {
                        this.loading = false;
                        this.msg.showMessage('error-message',err);
                    }
                );
            }

            fr.readAsText(file,'ISO-8859-4');
        }else{
            console.log("Seleccione un archivo");
        }
	}

	setHref(){
		let params = [];
        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
        
        let host_api = this.ss.getData('host_api');
        return host_api + "/proveedores/CargaMasiva/excel?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') + "&tk=" + this.ss.getData('api-token');
	}

}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/proveedor-list/proveedor-list.component.ts